import React, {FC} from "react";
import ButtonPrimary from "components/Button/ButtonPrimary";
import Textarea from "components/Textarea/Textarea";
import ButtonSecondary from "../../components/Button/ButtonSecondary";

export interface SingleCommentFormProps {
  className?: string;
  commentId?: number;
  onClickSubmit: (id?: any) => void;
  onClickCancel: (id?: any) => void;
  onChange: (id?: any) => void;
  textareaRef?: React.MutableRefObject<null>;
  defaultValue?: string;
  rows?: number;
}

const SingleCommentForm: FC<SingleCommentFormProps> = ({ className = "mt-5",
                                                         commentId,
                                                         onClickSubmit,
                                                         onClickCancel,
                                                         onChange,
                                                         textareaRef,
                                                         defaultValue = "",
                                                         rows = 4,
                                                       }) => {
  return (
    <form onSubmit={(e) => onClickSubmit(e)} className={`nc-SingleCommentForm ${className}`}>
      <Textarea
        placeholder="Write a comment..."
        ref={textareaRef}
        required={true}
        defaultValue={defaultValue}
        rows={rows}
        onChange={(e) => onChange(e)}
      />
      <div className="mt-2 space-x-3">
        <ButtonPrimary type="submit">
          Submit
        </ButtonPrimary>
        <ButtonSecondary type="reset" onClick={onClickCancel}>
          Cancel
        </ButtonSecondary>
      </div>
    </form>
);
};

export default SingleCommentForm;
